// Single source of truth for site content — easy to customize
export const SITE = {
  business: {
    name: "Powerz Auto Electrical",
    fullName: "Powerz Auto-Electrical & Airconditioning",
    tagline: "Auto Electrical • Under-Bonnet Dual Batteries • Auto Air Conditioning",
    phone: "0428 182 015",
    phoneTel: "+61428182015",
    email: "accounts@powerzautoelectrical.com.au",
    address: {
      line1: "2a/3 Hitech Dr",
      suburb: "Kunda Park",
      state: "QLD",
      postcode: "4556",
      country: "AU",
      full: "2a/3 Hitech Dr, Kunda Park QLD 4556",
    },
    serviceArea:
      "Customers come to us from Maroochydore, Caloundra, Noosa & all Sunshine Coast",
    hours: [
      { day: "Mon – Thu", time: "7:30am – 4:00pm" },
      { day: "Friday", time: "7:30am – 2:00pm" },
      { day: "Sat – Sun", time: "Closed" },
    ],
    geo: { lat: -26.6840, lng: 153.0840 },
    logo: "https://customer-assets.emergentagent.com/job_towing-electrics-qld/artifacts/jg9wglox_Trans%20Logo.png",
    instagram: "https://www.instagram.com/powerz_autoelectrical/",
    instagramHandle: "@powerz_autoelectrical",
    facebook: "https://www.facebook.com/102715111861610/",
    legalNote: "Registered Australian company (Pty Ltd) • ARC-licensed workshop",
    googleReviewUrl: "https://g.page/r/CXjX6f7bHEoPEBM/review",
    googleProfileUrl: "https://g.page/r/CXjX6f7bHEoPEBM",
    hourlyRate: "$165/hr",
    hourlyRateNote: "GST included • 1-hour minimum",
  },
  shop: {
    categories: [
      {
        slug: "haltech",
        name: "Haltech",
        kicker: "ECUs, tuning & engine management",
        desc: "Haltech engine management systems, ECUs, wiring harnesses, dashboards and accessories. Sales, install & tuning advice.",
      },
      {
        slug: "4wd-accessories",
        name: "4WD Accessories",
        kicker: "Vehicle-side accessory installs",
        desc: "Under-bonnet dual battery systems, driving lights, spotlights, UHFs, dashcams and reverse cameras — all installed clean at our Kunda Park workshop.",
      },
      {
        slug: "under-bonnet-dual-battery",
        name: "Under-Bonnet Dual Battery",
        kicker: "AGM auxiliaries — factory location",
        desc: "Under-bonnet dual battery installs — AGM auxiliary batteries mounted in the factory tray location with REDARC BCDC DC-DC chargers. Clean, hidden, under the bonnet.",
      },
      {
        slug: "dc-dc-chargers",
        name: "DC-DC Chargers",
        kicker: "Under-bonnet battery charging",
        desc: "REDARC BCDC, Enerdrive ePower and Projecta IDC DC-DC / B2B chargers — sized correctly for your alternator and under-bonnet AGM auxiliary battery.",
      },
      {
        slug: "driving-lights",
        name: "Driving Lights",
        kicker: "Light bars, spots & work lights",
        desc: "Stedi, Lightforce, Roadvision and Hella — driving lights, light bars and spotlights. Installed with proper relays, fusing and harness kits.",
      },
      {
        slug: "switches-panels",
        name: "Switches & Panels",
        kicker: "Custom dash & accessory control",
        desc: "Carling-style rocker switches, switch panels, fuse blocks and relays to wire your accessories cleanly.",
      },
      {
        slug: "wiring-cable",
        name: "Wiring & Cable",
        kicker: "Harnesses, plugs, cable & lugs",
        desc: "Driving-light harnesses, dual-battery harness kits, Anderson plugs (50A & 175A), 6 / 8 B&S cable, lugs and heat-shrink — all the bits we use on every install.",
      },
      {
        slug: "uhf",
        name: "UHF's",
        kicker: "Comms gear for the bush",
        desc: "GME and Uniden UHF radios, antennas, mounting brackets and accessory packs. Sales and clean install at the workshop.",
      },
      {
        slug: "towing-electrics",
        name: "Towing Electrics",
        kicker: "Trailer wiring, brake controllers & more",
        desc: "REDARC Tow-Pro brake controllers, 7 & 12-pin trailer plugs, Anderson plug kits and breakaway systems — fitted on the tow vehicle side.",
      },
      {
        slug: "reverse-dash-cams",
        name: "Reverse & Dash Cams",
        kicker: "Eyes on the road and the trailer",
        desc: "Reverse camera kits for utes and trailers + dash cams for daily-driver protection. Sales and install at our Kunda Park workshop.",
      },
    ],
    // Add products here as they come in. Each product belongs to a category by slug.
    products: [
      // Example shape:
      // { slug: "haltech-elite-2500", category: "haltech", name: "Haltech Elite 2500 ECU", price: "POA", image: "/gallery/auto-electrical-repair-diagnostics-sunshine-coast.jpg", short: "Mid-tier programmable ECU…" },
    ],
  },
  brand: {
    primary: "#5EE6E6",
    primaryHover: "#3CC9C9",
    bg: "#000000",
    surface: "#0A0A0A",
    card: "#111111",
  },
  hero: {
    eyebrow: "TOWING ELECTRICS & 4WD SPECIALISTS • KUNDA PARK WORKSHOP",
    headline: "AUTO ELECTRICIAN\nSUNSHINE COAST",
    headlineTail: "— 4WD, Towing & REDARC Installs",
    slogan: "Power. Precision. Performance.",
    sub: "Powerz Auto Electrical is the Sunshine Coast's towing electrics workshop — REDARC Tow-Pro brake controllers, 12 pin trailer plugs and Anderson plug installs done on the tow vehicle, by the book, at our Kunda Park workshop. We also handle under-bonnet dual battery systems, 4x4 auto electrical and ARC-licensed auto air conditioning. Registered company, 95+ five-star Google reviews, 12-month workmanship warranty.",
    image: "/gallery/sunshine-coast-auto-electrical-workshop.jpg",
  },
  services: [
    {
      key: "towing-electrics",
      href: "/services/towing-electrics-sunshine-coast",
      title: "Towing Electrics",
      kicker: "Tow-Pro • 12 pin • Anderson — tow safe, tow legal",
      desc: "Our core specialty. REDARC Tow-Pro Elite brake controllers, 12 pin trailer plugs, grey Anderson plugs and breakaway systems — fitted on the tow vehicle at our Kunda Park workshop and tested on a trailer before you leave.",
      icon: "Cable",
      image: "/gallery/towing-electrics-trailer-wiring-sunshine-coast.jpg",
      bullets: [
        "REDARC Tow-Pro Elite — from $805",
        "12 pin trailer plugs — from $495*",
        "Grey Anderson plugs — from $495",
        "Breakaway systems & caravan tow prep",
      ],
    },
    {
      key: "auto-electrical",
      href: "/services/auto-electrician-sunshine-coast",
      title: "Auto Electrical",
      kicker: "Diagnostics, repairs & rewires",
      desc: "Battery, alternator, starter motor, ECU faults, wiring repairs, lighting and full vehicle diagnostics — cars, trucks, machinery & marine.",
      icon: "Zap",
      image: "/gallery/auto-electrical-repair-diagnostics-sunshine-coast.jpg",
      bullets: [
        "Auto electrical fault finding",
        "Battery & alternator service",
        "Starter motors & ignition",
        "Wiring repairs & rewires",
      ],
    },
    {
      key: "under-bonnet-dual-battery",
      href: "/services/dual-battery-systems",
      title: "Under-Bonnet Dual Battery",
      kicker: "AGM auxiliaries — factory location",
      desc: "Under-bonnet dual battery installs — AGM auxiliary batteries mounted in the factory tray location, REDARC BCDC DC-DC charger, clean hidden wiring. No boot batteries, no lost storage space.",
      icon: "BatteryCharging",
      image: "/gallery/4wd-dual-battery-fitout-sunshine-coast.jpg",
      bullets: [
        "AGM auxiliary — factory tray fitment",
        "REDARC BCDC DC-DC charging",
        "Anderson outputs for accessory power",
        "Hidden loomed wiring — factory look",
      ],
    },
    {
      key: "4wd-accessories",
      href: "/services/4x4-auto-electrical-sunshine-coast",
      title: "4WD Accessories Fitting",
      kicker: "Vehicle-side installs",
      desc: "Driving lights, spotlights, LED light bars, UHF radios, dashcams and reverse cameras — installed with proper relays, fusing and clean loom routing at our Kunda Park workshop.",
      icon: "Truck",
      image: "/builds/kia-tasman-spotlight-install-doug-maroochydore-sunshine-coast.webp",
      bullets: [
        "Driving lights & spotlights",
        "LED light bars",
        "UHF radios & antennas",
        "Reverse & dash cameras",
      ],
    },
    {
      key: "auto-air",
      href: "/services/auto-air-conditioning",
      title: "Auto Air Conditioning",
      kicker: "Cold air, every drive",
      desc: "Auto A/C service from $154 — nitrogen pressure test, valve reseal, high & low pressure check and regas. Leak detection, compressor & condenser replacement for cars, 4WDs, trucks and machinery.",
      icon: "Snowflake",
      image: "/gallery/auto-air-conditioning-service-sunshine-coast.jpg",
      bullets: [
        "A/C service (from $154)",
        "Leak detection & repair",
        "Compressor replacement",
        "Truck & machinery A/C",
      ],
    },
  ],
  trustBadges: [
    "Licensed Auto Electrician",
    "Sunshine Coast Local",
    "12-Month Workmanship Warranty",
    "ARC-Licensed Workshop",
    "Registered Company (Pty Ltd)",
  ],
  whyUs: [
    {
      title: "Towing Electrics Specialists",
      desc: "Tow-Pro brake controllers, 12 pin plugs and Anderson plugs are our bread and butter — manufacturer-spec wiring, tested on a trailer before you leave.",
    },
    {
      title: "Straight-Up Honest",
      desc: "Written quotes up-front, no jargon. We tell you what's needed and what isn't — and what it'll cost before we start.",
    },
    {
      title: "Under-Bonnet Specialists",
      desc: "Factory-location dual battery installs done clean — no boot batteries, no lost storage space.",
    },
    {
      title: "Kunda Park Workshop",
      desc: "All work done at our fully-equipped Kunda Park workshop — 2a/3 Hitech Dr. Every tool, every part, every job under one roof.",
    },
  ],
  serviceAreas: [
    "Maroochydore",
    "Mooloolaba",
    "Caloundra",
    "Noosa",
    "Buderim",
    "Kunda Park",
    "Nambour",
    "Sippy Downs",
    "Coolum",
    "Mount Coolum",
    "Yaroomba",
    "Peregian",
    "Kawana",
    "Bli Bli",
    "Palmwoods",
    "Yandina",
    "Eumundi",
    "Tewantin",
    "Beerwah",
    "Landsborough",
  ],
  driveTimes: {
    "Kunda Park": "You're here",
    Buderim: "~8 min",
    Maroochydore: "~10 min",
    "Sippy Downs": "~10 min",
    Mooloolaba: "~12 min",
    "Bli Bli": "~12 min",
    Nambour: "~15 min",
    Kawana: "~15 min",
    Palmwoods: "~15 min",
    "Mount Coolum": "~18 min",
    Coolum: "~20 min",
    Yaroomba: "~20 min",
    Yandina: "~20 min",
    Caloundra: "~25 min",
    Peregian: "~25 min",
    Eumundi: "~25 min",
    Landsborough: "~25 min",
    Beerwah: "~30 min",
    Noosa: "~35 min",
    Tewantin: "~35 min",
  },
  gallery: [
    {
      src: "/builds/200-series-landcruiser-under-bonnet-dual-battery-install-sunshine-coast.jpg",
      alt: "200 Series LandCruiser V8 under-bonnet dual battery install at Powerz Auto Electrical, Kunda Park Sunshine Coast",
      caption: "200 Series V8 · Under-bonnet dual battery · Kunda Park workshop",
    },
    {
      src: "/builds/79-series-landcruiser-redarc-towpro-install-colin-maroochydore-sunshine-coast.webp",
      alt: "Colin's 79 Series LandCruiser REDARC Tow-Pro Elite install — Powerz Auto Electrical Sunshine Coast",
      caption: "Colin's 79 Series · REDARC Tow-Pro Elite · Maroochydore",
    },
    {
      src: "/gallery/underglow-kit-install-bmw-m3-powerz-auto-electrical-sunshine-coast.webp",
      alt: "BMW M3 full RGB underglow kit installed by Powerz Auto Electrical, Sunshine Coast",
      caption: "BMW M3 · Full RGB underglow · Kunda Park workshop",
    },
    {
      src: "/builds/chris-ford-everest-under-bonnet-dual-battery-jump-point-coolum-sunshine-coast.jpg",
      alt: "Chris' Ford Everest under-bonnet dual battery with dedicated jump-start point — Powerz Auto Electrical Coolum",
      caption: "Chris' Ford Everest · Dual battery + remote jump point · Coolum",
    },
    {
      src: "/builds/gtr-r35-electrical-diagnostic-repair-jacob-sippy-downs-sunshine-coast.webp",
      alt: "Jacob's Nissan GTR R35 electrical diagnostic and repair — Powerz Auto Electrical Sunshine Coast",
      caption: "Jacob's GTR R35 · Performance electrical diagnostic · Sippy Downs",
    },
    {
      src: "/gallery/beacon-buzzer-install-road-vision-low-profile-powerz-auto-electrical-sunshine-coast.webp",
      alt: "Roadvision low-profile beacon and reverse buzzer install on a work ute — Powerz Auto Electrical Sunshine Coast",
      caption: "Roadvision low-profile beacon + reverse buzzer · Work ute fitout",
    },
    {
      src: "/builds/classic-mercedes-280s-collectible-air-conditioning-service-powerz-auto-electrical-sunshine-coast.jpg",
      alt: "Classic Mercedes-Benz 280S collectible auto air conditioning service — Powerz Auto Electrical Sunshine Coast",
      caption: "Classic Mercedes 280S · Collectible A/C service · Kunda Park",
    },
    {
      src: "/builds/kia-tasman-spotlight-install-doug-maroochydore-sunshine-coast.webp",
      alt: "Doug's Kia Tasman spotlight install — Powerz Auto Electrical Maroochydore",
      caption: "Doug's Kia Tasman · Spotlight install · Maroochydore",
    },
  ],
  testimonials: [
    {
      name: "Jase M.",
      vehicle: "Hilux N80",
      quote:
        "Under-bonnet dual battery + a light bar setup that actually works. Cleanest wiring I've ever seen — these blokes know their stuff.",
    },
    {
      name: "Kara L.",
      vehicle: "Prado 150",
      quote:
        "Sorted my brake controller and trailer wiring same day. Honest pricing, friendly service. Won't go anywhere else on the Coast.",
    },
    {
      name: "Dave R.",
      vehicle: "Ranger PX3",
      quote:
        "A/C regas + a stubborn electrical fault three other shops couldn't find. Powerz had it diagnosed in an hour. Legends.",
    },
  ],
  faq: [
    {
      q: "How much does Powerz Auto Electrical charge per hour?",
      a: "Our standard workshop rate is $165 per hour, GST included, with a 1-hour minimum charge on all jobs. We give up-front quotes for larger jobs (under-bonnet dual battery installs, REDARC Tow-Pro installs, A/C work) so you know exactly where you stand before any spanners come out.",
    },
    {
      q: "Will you install parts I've bought myself?",
      a: "Case-by-case, yes — but please check with us before you buy. Conditions apply: there's no warranty on the part itself (only on our install workmanship), labour to deal with a faulty, incomplete or incompatible part is chargeable at the workshop rate, we're not liable for any damage a customer-supplied part causes, and we can refuse to fit anything we consider unsafe or non-compliant. Parts must arrive complete with all hardware, harnesses and fitting instructions. Full terms are on our Policies page.",
    },
    {
      q: "Do you work on European cars (BMW, Audi, Mercedes, VW)?",
      a: "Please note: Powerz Auto Electrical is selective with European vehicles (BMW, Audi, Mercedes, VW, etc.). We'll assess each Euro job individually and may refer complex factory-system work to a specialist. Our day-to-day focus is Aussie and Japanese makes, 4WDs, utes, trucks and machinery. Give us a call to chat about your specific vehicle.",
    },
    {
      q: "Do you work on caravans or camper vans?",
      a: "No. Powerz Auto Electrical does NOT work on caravans or camper vans. We are an auto electrical workshop — we only work on Vehicles (4WDs, utes, sedans, trucks, machinery and the like). Our work stops at the trailer plug or Anderson plug on the tow vehicle. Caravan-side wiring, camper-van fitouts, fridge / water-pump wiring, solar, inverters, 240V and any interior work on caravans or camper vans must be carried out by a dedicated caravan / camper-van electrical specialist. We also accept no responsibility for the condition of the caravan or camper van, its internal wiring, charging system, fuses, appliances or any pre-existing faults. For 12 pin and Red Anderson installs you must supply a current wiring diagram for the caravan before we book the job in — no diagram, no booking.",
    },
    {
      q: "What's covered under the 12-month workmanship warranty?",
      a: "Every job we do is backed by a 12-month workmanship warranty on parts we supply and install. To keep things fair for everyone, a few standard conditions apply:\n\n• Customer-supplied parts: we may fit them case-by-case, but the warranty covers our installation workmanship only — not the part. Any labour caused by a faulty, incompatible or incomplete customer-supplied part is chargeable, and we don't accept liability for damage the part causes. See our Policies page for the full terms.\n• If our work is tampered with, modified or repaired by another shop, the warranty is voided.\n• If a part we've installed fails as a result of another part's wear and tear or pre-existing fault, the warranty on our work is voided for that fault.\n\nGenuine workmanship issues? Bring the vehicle back and we'll sort it out — that's a promise.",
    },
    {
      q: "Do you install dual battery systems for 4WDs?",
      a: "Yes — under-bonnet dual battery installs are our specialty. AGM auxiliary batteries mounted in the factory tray location, REDARC BCDC DC-DC charging, clean hidden wiring — no boot batteries, no lost storage space. Every install comes with proper fusing, heat-shrink terminations and a 12-month workmanship warranty. Customers come to us from Maroochydore, Caloundra, Noosa and the wider Sunshine Coast.",
    },
    {
      q: "Can you fit a brake controller and trailer wiring on the Sunshine Coast?",
      a: "Absolutely — towing electrics is our core specialty. We do 12 pin trailer plugs (from $495), REDARC Tow-Pro Elite brake controllers (from $805), grey Anderson plug installs (from $495) and breakaway systems — all done on the tow vehicle side at our Kunda Park workshop, and tested on a trailer before you leave. Price shown is for a basic 12 pin plug install. Additional charges may apply if extra pins or circuits are required. A current caravan wiring diagram is required from the customer before any 12 pin or Red Anderson plug install is booked in.",
    },
    {
      q: "Do you install accessories like driving lights, spotlights, UHF radios and reverse cameras?",
      a: "Yes — vehicle-side accessory installs are a regular job for us. Stedi, Lightforce and Roadvision driving lights, LED bars and spotlights, GME and Uniden UHF radios and antennas, reverse cameras and dashcams. We install with proper relays, fusing, heat-shrink terminations and clean loom routing. Note: our specialty is under-bonnet dual battery — we do NOT do behind-seat dual battery, off-grid setups or full touring fitouts.",
    },
    {
      q: "Where is Powerz Auto Electrical located?",
      a: "Our workshop is at 2a/3 Hitech Dr, Kunda Park QLD 4556 — central to the entire Sunshine Coast. Customers drive in from Maroochydore, Mooloolaba, Caloundra, Noosa, Buderim, Coolum, Nambour, Sippy Downs, Kawana and every suburb between Beerwah and Tewantin.",
    },
    {
      q: "Do you do auto air conditioning service and repairs?",
      a: "Yes — full auto air conditioning service for cars, 4WDs, trucks and machinery. Our A/C Service starts at $154 (GST included) and includes a nitrogen pressure test, valve reseal, high & low side system pressure check and a regas. Important: under Australian refrigerant law (ARC) we cannot simply re-gas a system if a leak is detected — leaks must be repaired first. Refrigerant handled to spec by ARC-licensed technicians.",
    },
    {
      q: "What hours are you open?",
      a: "Monday to Thursday 7:30am to 4:00pm, Friday 7:30am to 2:00pm. Closed Saturday and Sunday. Bookings recommended — phone lines open during business hours.",
    },
    {
      q: "Do I need to bring my vehicle to your workshop?",
      a: "Yes — all work is carried out at our Kunda Park workshop (2a/3 Hitech Dr), where we have the full set of tools, diagnostic gear and parts on hand. Drop your vehicle in and we'll have it sorted properly.",
    },
    {
      q: "What kinds of vehicles do you work on?",
      a: "Vehicles only — 4WDs, utes, passenger cars, trucks and machinery. Primarily Aussie and Japanese makes. From a daily-driver alternator swap to a clean under-bonnet dual battery install. We don't often work on European vehicles (BMW, Audi, Mercedes, VW) — for those, a Euro specialist will usually do a better job. We do NOT work on caravans or camper vans (see our caravan / camper-van policy FAQ above). Give us a call to check your specific vehicle.",
    },
  ],
};

export const SERVICE_OPTIONS = [
  "Auto Electrical Repair",
  "4WD Accessory Fitting",
  "Towing Electrics",
  "Auto Air Conditioning",
  "Diagnostics / Fault Finding",
  "Other",
];
